import React from 'react';
import PropTypes from 'prop-types';

import { convertToTitleCase } from 'lib/utils/stringUtils';
import { getURL, GLOBAL_VENDORS_CHAIN_LOCATIONS } from 'lib/networking/endpoints';
import useGet from 'lib/hooks/useGet';
import { VENDOR_FIELDS } from 'components/manage_vendors/vendor_details/VendorDetailSplitView';

function VendorDisplayField({ label, vendor }) {
  const { data: chainLocationsResponse } = useGet(
    getURL(GLOBAL_VENDORS_CHAIN_LOCATIONS, { vendor_id: vendor.id }),
    {},
    label !== VENDOR_FIELDS.PRIMARY_SOURCE,
  );

  if (label === VENDOR_FIELDS.PRIMARY_SOURCE) {
    const location = (chainLocationsResponse?.data || []).find(
      location => location.id === vendor[label],
    );
    return <p>{location?.name || '-'}</p>;
  }

  if (label === 'excluded_p0_sync_attributes') {
    return (
      <div>
        {vendor[label] ? (
          vendor[label].split(',').map((phrase, index) => <p key={index}>&bull; {phrase}</p>)
        ) : (
          <p>-</p>
        )}
      </div>
    );
  }

  if (
    label === 'rejected_brand_names' ||
    label === 'chains' ||
    label === 'alliance' ||
    label === 'third_party'
  ) {
    return (
      <div>
        {vendor[label] && vendor[label].length > 0 ? (
          vendor[label].map((item, index) => <p key={index}>&bull; {item.name || item}</p>)
        ) : (
          <p>-</p>
        )}
      </div>
    );
  }

  if (label === 'vendor_category') {
    return <p>{convertToTitleCase(vendor[label]) || '-'}</p>;
  }

  return <p>{vendor[label] || '-'}</p>;
}

VendorDisplayField.propTypes = {
  label: PropTypes.string.isRequired,
  vendor: PropTypes.object.isRequired,
};

export default VendorDisplayField;
